import { useEffect, useRef } from 'react';

const pollerFunction = (cb: () => void, interval: number): number => {
    return window.setInterval(cb, interval);
};

/**
 * This creates a poller runs in an interval based on document visibility
 * @param cb callback function for that poll
 * @param interval interval for that poll, default interval is Infinity
 */
export const usePoller = (cb: () => void, interval = Infinity) => {
    const pollerTimerId = useRef(-1);

    useEffect(() => {
        pollerTimerId.current = pollerFunction(cb, interval);
        const visibilityHandler = () => {
            if (document.hidden) {
                window.clearInterval(pollerTimerId.current);
            } else if (cb) {
                pollerTimerId.current = pollerFunction(cb, interval);
            }
        };

        document.addEventListener('visibilitychange', visibilityHandler);
        return () => {
            document.removeEventListener('visibilitychange', visibilityHandler);
            if (pollerTimerId.current > 0) {
                window.clearInterval(pollerTimerId.current);
            }
        };
    }, [cb, interval]);
};
